export const MenuList = props => (
  <div
    className="relative py-1 rounded-base shadow-lg bg-surface border border-line-subdued overflow-auto"
    style={{ maxHeight: '236px' }}
    {...props}
  />
)
